// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"600f5d26","453":"64cb4918","806":"57a920ab"}[chunkId] + ".chunk.js";
};